import { AnyAction, Reducer } from 'redux';

export const STORE_M_FILES_UPLOAD = 'Manufacturer/files-upload';

export const STORE_M_PROGRESS = 'progress/file-upload';
export const STORE_M_SENDING_INPROGRESS = 'send/sending-inprogress';

export const STORE_M_LAB_DATA = 'Lab/all-data-api';
export const STORE_M_CHOSEN_LAB_DATA = 'Lab/chosen-data';
export const STORE_M_BRANCH_DATA = 'branch/all-data-api';
export const STORE_M_CHOSEN_BRANCH_DATA = 'branch/chosen-data';

export interface LabData {
    rowno?: string;
    custname?: string;
    custcode?: string;
    dsoft?: string;
    destination?: string;
    tat?: string;
    uname?: string;
    crbatch?: string;
}

export interface BranchData {
    rowno: string;
    sbu_name: string;
}

export interface MFileUploadState {
    mfilesUpload: Array<File>;
    mprogress: Array<number>;
    mbranchData: BranchData[];
    mbranchType: string;
    mlabData: LabData[];
    mlabChosen: string;
    msending: boolean;
}

const initialState: MFileUploadState = {
    mfilesUpload: [],
    mprogress: [],
    mbranchData: [],
    mbranchType: '0',
    mlabData: [],
    mlabChosen: '0',
    msending: false
};

const reducer: Reducer<MFileUploadState> = (state: MFileUploadState = initialState, action: AnyAction): MFileUploadState => {
    switch (action.type) {
        case STORE_M_FILES_UPLOAD:
            return {
                ...state,
                mfilesUpload: action.mfilesUpload
            };
        case STORE_M_PROGRESS:
            return {
                ...state,
                mprogress: action.mprogress
            };
        case STORE_M_SENDING_INPROGRESS:
            return {
                ...state,
                msending: action.msending
            };
        case STORE_M_LAB_DATA:
            return {
                ...state,
                mlabData: action.mlabData
            };
        case STORE_M_CHOSEN_LAB_DATA:
            return {
                ...state,
                mlabChosen: action.mlabChosen
            };
        case STORE_M_BRANCH_DATA:
            return {
                ...state,
                mbranchData: action.mbranchData
            };
        case STORE_M_CHOSEN_BRANCH_DATA:
            return {
                ...state,
                mbranchType: action.mbranchType
            };
        default:
            return state;
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/mfileupload.tsx